(ns global.endor.checkout.ui.style.base
  "Figma bottom level variables.
  https://www.figma.com/design/qayHX5iSCYdvEICGNpIBwJ/Endor-Assets-Library?node-id=0-1&p=f&vars=1&m=dev")

(def colors
  {:white "#FFFFFF"
   :black "#000000"

   :sky-blue-1 "#003E68"
   :sky-blue-2 "#0062A4"
   :sky-blue-3 "#5CA4CF"
   :sky-blue-4 "#88CAF2"
   :sky-blue-bright "#4BCCFF"

   :fire-red-1 "#721818"
   :fire-red-2 "#971A20"
   :fire-red-3 "#7F4C4D"
   :fire-red-4 "#D64901"
   :fire-red-bright "#D64901"

   :forest-green-1 "#093D2B"
   :forest-green-2 "#426A5C"
   :forest-green-3 "#87AA97"
   :forest-green-4 "#B5C9BE"
   :forest-green-bright "#27C564"

   #_:natural-black #_"#39332D"
   :earth-grey-1 "#877C6C"
   :earth-grey-2 "#DBD2C6"
   :earth-grey-3 "#EDE6DF"
   :earth-grey-4 "#FFFBF5"

   :sun-yellow-1 "#FFBD43"
   :sun-yellow-2 "#F9D59B"
   :sun-yellow-3 "#FFC37F"

   :light-sand "#F5EDE2"
   :butter-yellow "#FDECC8"
   :warm-fire "#EE763A"

   :transparent "rgba(0, 0, 0, 0.0)"

   :light-gray "#B2B2B2"})

(def spacing
  {:spacing-none 0
   :spacing-2 2
   :spacing-4 4
   :spacing-8 8
   :spacing-12 12
   :spacing-16 16
   :spacing-24 24
   :spacing-32 32
   :spacing-40 40
   :spacing-48 48
   :spacing-64 64
   :spacing-80 80
   :spacing-96 96
   :spacing-128 128
   :spacing-160 160
   :spacing-196 196})

(def radius
  {:radius-none 0
   :radius-2 2
   :radius-4 4
   :radius-8 8
   :radius-12 12
   :radius-16 16
   :radius-24 24
   :radius-32 32
   :radius-40 40
   :radius-48 48
   :radius-64 64
   :radius-80 80
   :radius-96 96
   :radius-120 120
   :radius-160 160
   :radius-full 999})

(def text-size
  {:text-size-10 10
   :text-size-12 12
   :text-size-14 14
   :text-size-16 16
   :text-size-18 18
   :text-size-24 24
   :text-size-32 32
   :text-size-40 40
   :text-size-48 48
   :text-size-56 56
   :text-size-64 64
   :text-size-68 68
   :text-size-80 80
   :text-size-88 88
   :text-size-96 96})
